<template>
  <div class="main">
    <Header 
      :show="true"
      title="更新货车"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        left-icon="info-o"
        color="#ed6a0c" background="#FFFBE8" 
        text="注意：货车名称不能跟现有的名称一样"
      />
      <van-form 
      ref="update"
        @submit="submit"
      >
        <van-field
        v-model.trim="listQuery.plateNumber"
        label="车牌号"
        placeholder="请输入货车车牌号"
        required
        disabled
        :rules="[{ validator: validCheckPlateNumber, message: '' }]"
      />
      <van-field
        clickable
        name="picker"
        :value="listQuery.type"
        label="货车类别"
        placeholder="选择货车类别"
        required
        @click="type.show = true"
        :rules="[{ validator: validCheckName, message: '请选择货车类别' }]"
      />
      <van-popup v-model="type.show" position="bottom">
        <van-picker
          show-toolbar
          :columns="type.columns"
          @confirm="handleTruckTypeSelect"
          @cancel="type.show = false"
        />
      </van-popup>
      <van-field
        clickable
        name="picker"
        :value="listQuery.size"
        label="货车大小"
        placeholder="选择货车大小"
        required
        @click="size.show = true"
        :rules="[{ validator: validName, message: '请选择货车大小' }]"
      />
      <van-popup v-model="size.show" position="bottom">
        <van-picker
          show-toolbar
          :columns="size.columns"
          @confirm="handleTruckSizeSelect"
          @cancel="size.show = false"
        />
      </van-popup>
      <van-field
        v-model.trim="listQuery.tareWeight"
        label="皮重"
        placeholder="请输入货车皮重"
        required
        :rules="[{ validator: validNumberFloat, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.loadCapacity"
        label="装载量"
        placeholder="请输入货车装载量"
        required
        :rules="[{ validator: validNumberFloat, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.driver"
        label="司机"
        placeholder="请输货车司机"
        :rules="[{ validator: validName, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.phone"
        label="手机号码"
        placeholder="请输货车手机号码"
        :rules="[{ validator: validPhone, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.remark"
        rows="2"
        autosize
        label="说明"
        type="textarea"
        maxlength="100"
        placeholder="请输入货车说明"
        show-word-limit
      />
      <div style="margin: .6rem 1rem;" v-if="checkPermission([173])">
        <van-button round block type="info" native-type="submit">
          确定
        </van-button>
      </div>
    </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { isPlateNumber, isUserName, isPassword, isChinese, isPhone, isEmail, isNumberFloat } from '@/utils/validate.js'
  import { updateOne } from '@/api/truck.js'

  export default {
    name: "ServiceSystemTruckUpdate",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        isLoading: false,
        loading: false,
        listQuery: {
        serial: '',
          plateNumber: '',
          type: '商砼货车',
          size: '大型车辆',
          tareWeight: '',
          loadCapacity: '',
          driver: '',
          phone: '',
          remark: ''
        },
        type: {
          show: false,
          columns: ['商砼货车', '罐装货车', '骨料货车', '其他货车', '固定车辆']
        },
        size: {
          show: false,
          columns: ['大型车辆', '中型车辆', '小型车辆', '其他车辆']
        }
      }
    },
    watch: {
      
    },
    computed: {

    },
    beforeCreate() {
      
    },
    created() {
      
    },
    beforeMount() {
      
    },
    mounted() {
      this.listQuery = this.$route.query
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$refs.udpate.submit()
      },
      submit() {
        Dialog.confirm({
          title: '确认更新货车？',
          message: '货车车牌号：' + this.listQuery.plateNumber
        }).then(() => {
          this.loading = true
          const data = {
            id: this.listQuery.serial,
            plateNumber: this.listQuery.plateNumber,
            type: this.listQuery.type,
            truckType: this.listQuery.size,
            tareWeight: this.listQuery.tareWeight,
            loadCapacity: this.listQuery.loadCapacity,
            driver: this.listQuery.driver,
            phone: this.listQuery.phone,
            remark: this.listQuery.remark
          }
          updateOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '更新货车', data.message)) {
              this.$router.push({ path:'/service/system/truck', query: {} })
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, '更新货车', '取消')
        })
      },
      validNumberFloat(value) {
        return new Promise((resolve) => {
          const result = isNumberFloat(value, 2, 20)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      validName(value) {
        return new Promise((resolve) => {
          const result = isChinese(value, 2, 20)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      validPhone(value) {
        return new Promise((resolve) => {
          const result = isPhone(value, 11, 11)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      validPlateNumber(value) {
        return new Promise((resolve) => {
          const result = isPlateNumber(value, 2, 20)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      handleTruckSizeSelect(value) {
        this.listQuery.size = value
        this.size.show = false
      },
      handleTruckTypeSelect(value) {
        this.listQuery.type = value
        this.type.show = false
      },
    }
  }
</script>

<style lang="less" scoped>
  // 系统样式修改
  ::v-deep .van-field__label {
    width: 5em;
  }
  ::v-deep .van-checkbox {
    padding: 3px 0;
  }
  ::v-deep .van-checkbox__icon {
    font-size: 4.5vw;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F8F8F8; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
